<template>
  <div>

    <v-menu
      v-model="dateMenu"
      :close-on-content-click="false"
      max-width="290"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          :value="`${year} / ${month}`"
          clearable
          label="月份"
          readonly
          v-on="on"
          style="margin-top: 24px;"
        ></v-text-field>
      </template>
      <v-date-picker
        :value="`${year}-${month}`"
        type="month"
        @change="onDateChanged"
        :max="currentYearMonth"
      ></v-date-picker>

    </v-menu>

    當月獎金: ${{(bonusOfTaskWorkingItemOfTheMonth+bonusOfWorkOrderOfTheMonth)| amountFormat}}

    <v-simple-table class="table-black">
      <template v-slot:default>
        <template v-for="(project, idx) in mightHaveBonusProjects">
          <tr
            v-if="idx != 0"
            class="table-divider"
            :key="`thead-biding-${project.ID}`"
          >
            <th
              colspan="6"
              class="text-left"
            >&nbsp;</th>
          </tr>
          <tr :key="`thead-project-${project.ID}`">
            <th
              colspan="6"
              class="text-left headline title-column"
            >
              專案: {{project.Name}}
            </th>
          </tr>
          <project-bonus-table
            :key="`tbody-project-bonus-${project.ID}`"
            :project="project"
            :year="year"
            :month="month"
          />
        </template>

        <template>
          <tr
            class="table-divider"
            :key="`thead-biding-work-order-workorder`"
          >
            <th
              colspan="6"
              class="text-left"
            >&nbsp;</th>
          </tr>
          <tr :key="`thead-work-order`">
            <th
              colspan="6"
              class="text-left headline title-column"
            >
              工單
            </th>
          </tr>
          <v-simple-table style="background-color: #555 !important;">
            <template v-slot:default>
              <thead v-if="mightHaveBonusWorkOrders.length">
                <tr>
                  <th colspan="5">
                    <small style="font-size: 0.8em;color: #bbb;">
                      已領: {{issuedWorkOrderAmount|amountFormat}},
                      未領: {{notIssuedWorkOrderAmount|amountFormat}}
                    </small>
                  </th>
                </tr>
              </thead>
              <thead v-if="mightHaveBonusWorkOrders.length">
                <tr>
                  <th>工作內容</th>
                  <th>獎金</th>
                  <th>實發月份</th>
                  <th>核發管理員</th>
                </tr>
              </thead>
              <tr v-for="item in mightHaveBonusWorkOrders" :key="`work-order-${item.ID}`">
                <td>{{item.Content}}</td>
                <td>{{(item.Amount) | amountFormat}}</td>
                <td>
                  <span v-if="item.BonusReleasedAt">{{item.BonusReleasedAt | yearMonthFormat}}</span>
                  <span v-else-if="item.IssuedAt">預計下個月薪水</span>
                </td>
                <td>{{getBonusIssuer(item).Profile.Name}}</td>
              </tr>
            </template>
          </v-simple-table>

        </template>

        <span v-show="(!mightHaveBonusProjects || !mightHaveBonusProjects.length) && (!mightHaveBonusWorkOrders || !mightHaveBonusWorkOrders.length)">該月份並沒有獲取獎金</span>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import ProjectBonusTable from "./project-bonus-table.vue";
import filterMixin from "@/data/filters/filter-mixin.vue";
export default {
  mixins: [filterMixin],
  components: {
    ProjectBonusTable
  },
  data: () => ({
    isLoading: false,

    dateMenu: false,
    year: 2020,
    month: new Date().getMonth()+1
  }),
  computed: {
    headers() {
      let actionHeader = { text: "操作", value: "action" };
      return [{ text: "縣市名稱", value: "Name" }].concat(
        this.canEditCounty ? [actionHeader] : []
      );
    },
    mightHaveBonusWorkOrders () {
      return this.workOrders.filter(o => o.Status != '已完成').sort((o1, o2) => new Date(o1.Time) - new Date(o2.Time));
    },
    issuedWorkOrderAmount () {
      return this.mightHaveBonusWorkOrders.filter(o=>o.Status == '獎金發放中').reduce((sum,o)=>sum+o.Amount,0)
    },
    notIssuedWorkOrderAmount () {
      return this.mightHaveBonusWorkOrders.filter(o=>o.Status != '獎金發放中').reduce((sum,o)=>sum+o.Amount,0)
    },
    mightHaveBonusProjects() {
      return this.projects.filter(
        o =>
          this.taskWorkingItems
            .filter(item => item.Status != "被拒絕")
            .filter(item => item.ProjectID == o.ID)
            .filter(item => item.UserID == this.me.ID)
            .filter(item => this.isCurrentMonth 
                            ? 
                              true 
                            :
                              (
                                moment(item.BonusReleasedAt).format("yyyy/MM") == `${this.year}/${this.month<10?'0':''}${this.month}`
                                // moment(item.BonusReleasedAt).add(0, 'M').year() == this.year 
                                // && 
                                // moment(item.BonusReleasedAt).add(0, 'M').month() == this.month
                              )
          ).length > 0 
          ||
          (
            this.isCurrentMonth 
            ? 
              this.activeTaskList
              .filter(task => task.ProjectID == o.ID)
              .filter(task => task.ManagerID == this.me.ID).length > 0 
            : 
              false
          )
      );
    },
    currentYearMonth () {
      let now = new Date()
      const dd = n => n < 10 ? '0'+n : n
      return `${now.getFullYear()}-${dd(now.getMonth()+1)}`
    },
    bonusOfTaskWorkingItemOfTheMonth () {
      let taskWorkingItems = this.taskWorkingItems
            .filter(item => item.UserID == this.me.ID)
            .filter(item => {
              if(this.isCurrentMonth) return item.Status=='獎金發放中'
              let releasedAt = moment(item.BonusReleasedAt)//.add(0, 'M')
              let releasedYear = releasedAt.year()
              let releasedMonth = releasedAt.month()
              if (releasedMonth == 0) {
                releasedMonth = 12
                releasedYear -= 1
              }
              return releasedYear==this.year && releasedMonth == this.month
            })
      return taskWorkingItems.reduce((sum,o)=>sum+o.Bonus, 0)
    },
    bonusOfWorkOrderOfTheMonth () {
      let workOrders = this.workOrders
            .filter(item => item.UserID == this.me.ID)
            .filter(item => {
              if(this.isCurrentMonth) return item.Status=='獎金發放中'
              let releasedAt = moment(item.BonusReleasedAt)//.add(0, 'M')
              let releasedYear = releasedAt.year()
              let releasedMonth = releasedAt.month()
              if (releasedMonth == 0) {
                releasedMonth = 12
                releasedYear -= 1
              }
              return releasedYear==this.year && releasedMonth == this.month
            })
      return workOrders.reduce((sum,o)=>sum+o.Amount, 0)
    },
    isCurrentMonth () {
      let now = new Date()
      let isCurrentMonth = this.year == now.getFullYear() && this.month == now.getMonth()+1
      return isCurrentMonth
    },
    ...mapGetters([
      "me",
      "canEditCounty",
      "myLevel",
      "projects",
      "activeTaskList",
      "tasks",
      "users",
      "taskWorkingItems",
      "workOrders"
    ])
  },
  methods: {
    getBonusIssuer (item) {
      return this.users.find(o => o.ID == item.BonusIssuerID) || { Profile: {} }
    },
    onDateChanged(evt) {
      var arr = evt.split("-");
      this.year = parseInt(arr[0]) || 1;
      this.month = parseInt(arr[1]) || 1;
      this.dateMenu = false;
    }
  },
  created() {
    this.year = new Date().getYear() + 1900;
    this.month = new Date().getMonth() + 1;

    if (this.myLevel >= 10) {
      alert("沒有權限");
      this.$router.push({ name: "main" });
      return;
    }
    this.isLoading = true;

    Promise.all([
      this.$services.prepareDatas(this),
      // this.$services.prepareProjectDatas(this) // 20220501 發現 prepareDatas時就會prepareProductDatas
    ]).finally(() => {
      this.isLoading = false;
    });
  }
};
</script>